export default __webpack_public_path__ + "static/media/spices.eb395f50.jpg";